import React from "react";
import { createRoot, Root } from "react-dom/client";
import App from "./App";

const rootElement: HTMLDivElement = document.getElementById(
  "form-bond"
) as HTMLDivElement;
const root: Root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
    <div id="portals"></div>
  </React.StrictMode>
);
